import { CallStatus } from "@prisma/client";
import { CallDateBounds, CallDateWhere } from "@/app/types/call/CallDateWhere";
import { CallScopeFilter } from "@/app/types/call/CallScopeFilter";

export class UCallScope {
  private static readonly ALL = "all";
  private static readonly NONE = "na";

  public static parseMember(raw?: string | null): number | null | undefined {
    if (raw === UCallScope.NONE) {
      return null;
    }
    if (!raw) {
      return undefined;
    }
    const id = parseInt(raw, 10);
    return Number.isNaN(id) ? undefined : id;
  }

  public static parseType(raw?: string | null): string | null | undefined {
    if (raw === UCallScope.NONE) {
      return null;
    }
    return raw || undefined;
  }

  public static parseStatus(raw?: string | null): CallStatus | undefined {
    return raw && Object.values(CallStatus).includes(raw as CallStatus)
      ? (raw as CallStatus)
      : undefined;
  }

  public static serializeMember(memberId?: number | null): string | null {
    if (memberId === undefined) {
      return null;
    }
    return memberId === null ? UCallScope.NONE : String(memberId);
  }

  public static serializeType(type?: string | null): string | null {
    if (type === undefined) {
      return null;
    }
    return type === null ? UCallScope.NONE : type;
  }

  public static isFiltered(filter: CallScopeFilter): boolean {
    return (
      filter.memberId !== undefined || filter.type !== undefined || !!filter.from || !!filter.to
    );
  }

  public static queryKey(filter: CallScopeFilter): (string | number | null)[] {
    return [
      filter.memberId === undefined ? UCallScope.ALL : filter.memberId,
      filter.type === undefined ? UCallScope.ALL : filter.type,
      filter.from ?? UCallScope.ALL,
      filter.to ?? UCallScope.ALL,
    ];
  }

  public static dateBounds(filter: CallScopeFilter): CallDateBounds | null {
    if (!filter.from && !filter.to) {
      return null;
    }

    return {
      ...(filter.from ? { gte: new Date(`${filter.from}T00:00:00.000Z`) } : {}),
      ...(filter.to ? { lte: new Date(`${filter.to}T23:59:59.999Z`) } : {}),
    };
  }

  public static prismaDateWhere(filter: CallScopeFilter): CallDateWhere[] {
    const bounds = UCallScope.dateBounds(filter);
    if (!bounds) {
      return [];
    }

    return [{ callDate: bounds }, { callDate: null, createdAt: bounds }];
  }
}
